import { getAppConfigValue, getHTTPClient } from "@elliemae/pui-app-sdk";
import { apiWrapper } from "../../utils/apiWrapper";
const debugRestProxy = ({
  key,
  opaqueToken,
  payload,
  pathParameters,
  queryParameters
}) => apiWrapper(async () => {
  const client = getHTTPClient({
    baseURL: getAppConfigValue("serviceEndpoints.ppeServices"),
    headers: {
      "Content-Type": "application/json",
      "X-Opaque-Token": opaqueToken
    }
  });
  const { data } = await client.post(
    `/restProxy?${key}`,
    payload ?? {},
    {
      headers: {
        Key: key,
        ...pathParameters && {
          PathParameters: JSON.stringify(pathParameters)
        }
      },
      params: queryParameters
    }
  );
  return data;
});
export {
  debugRestProxy
};
